import { render, staticRenderFns } from "./CourseListDetails.vue?vue&type=template&id=450280de&scoped=true"
import script from "./CourseListDetails.vue?vue&type=script&lang=js"
export * from "./CourseListDetails.vue?vue&type=script&lang=js"
import style0 from "./CourseListDetails.vue?vue&type=style&index=0&id=450280de&prod&lang=less&scoped=true"
import style1 from "./CourseListDetails.vue?vue&type=style&index=1&id=450280de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450280de",
  null
  
)

export default component.exports